/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import useStyles from './styles';
import { Box } from '@mui/material';
import { LuiEmptyState } from '@jda/lui-common-component-library-mui5';

interface INoItemProps {
  title: string;
  subHeading: string;
}

const NoItems = ({ title, subHeading }: INoItemProps) => {
  const { classes } = useStyles();
  return (
    <Box id="empty-component-container" className={classes.title}>
      <LuiEmptyState data-testid="lui-empty-component" heading={title} subHeading={subHeading} />
    </Box>
  );
};

export default NoItems;
